"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var biLogger_1 = require("./../../utils/biLogger");
var interpolate_1 = require("./../../utils/interpolate");
var configURLS = require('./../../assets/config.json');
var MandatoryFields = /** @class */ (function () {
    function MandatoryFields() {
        var _this = this;
        this.fields = {};
        this.setMandatoryField = function (name, field) {
            _this.fields[name] = field;
        };
        this.getMandatoryFieldsMap = function () {
            var result = {};
            // TODO: Change with implementation of https://jira.wixpress.com/browse/WCN-2070
            var addressDetailKey = 'addressDetails';
            var addressDetailsKeys = ['street', 'houseNumber'];
            Object.keys(_this.fields).forEach(function (key) {
                if (addressDetailsKeys.indexOf(key) > -1) {
                    if (!result[addressDetailKey]) {
                        result[addressDetailKey] = {};
                    }
                    result[addressDetailKey][key] = _this.fields[key].value;
                }
                else {
                    result[key] = _this.fields[key].value;
                }
            });
            return result;
        };
        this.fetchMandatoryFields = function (config, country, host) { return __awaiter(_this, void 0, void 0, function () {
            var endpoint, provider, data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = this.getMandatoryFieldsEndpoint({ orderId: config.orderId, host: host });
                        provider = config.providerId || config.paymentMethod;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.get(endpoint, { params: { country: country, provider: provider } })];
                    case 2:
                        data = (_a.sent()).data;
                        this.logMandatoryFieldsLoaded({
                            appId: config.appId,
                            appInstanceId: config.appInstanceId,
                            paymentMethod: config.paymentMethod,
                            orderId: config.orderId,
                        }, data);
                        return [2 /*return*/, data];
                    case 3:
                        e_1 = _a.sent();
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.logMandatoryFieldsLoaded = function (_a, data) {
            var orderId = _a.orderId, paymentMethod = _a.paymentMethod, appId = _a.appId, appInstanceId = _a.appInstanceId;
            var mandatoryFields = data.mandatoryFields || [];
            biLogger_1.default.mandatoryFieldsLoaded({
                orderId: orderId, appId: appId, appInstanceId: appInstanceId, paymentMethod: paymentMethod,
                mandatoryFieldsList: mandatoryFields.map(function (field) { return field.fieldName; }),
            });
        };
        this.getMandatoryFieldsEndpoint = function (_a) {
            var orderId = _a.orderId, host = _a.host;
            var url = orderId
                ? host + interpolate_1.default(configURLS.mandatoryFieldsUrl, { orderId: orderId })
                : host + configURLS.mandatoryFieldsProviderUrl;
            return url;
        };
    }
    return MandatoryFields;
}());
exports.default = MandatoryFields;
//# sourceMappingURL=MandatoryFields.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-sdk/dist/src/modules/MandatoryFields/MandatoryFields.js
// module id = 427
// module chunks = 0 1